import {Placement_UI} from 'common/src/modules/campaignPlacements/placements.types';
import {CLStore} from 'common/src/redux/store';
import {PlacementsSummary} from '../placementsManagementTool.types';

export default function getPlacementsSummary(store: CLStore): PlacementsSummary {
  const state = store.getState();
  const campaign = state.campaignPage.campaignTree.campaign;

  if (!campaign) {
    return {
      isInCampaign: false,
      totalCount: 0,
      countByDsp: {},
      placementIdExamples: [],
      placementNameExamples: [],
      distinctEnvironments: [],
      customParams: {},
    };
  }

  const placements: Placement_UI[] = state.campaignPage.campaignTree.campaignPlacements;

  const totalCount = placements.length;
  const countByDsp: Record<string, number> = {};
  const placementIdSet = new Set<string>();
  const placementNameSet = new Set<string>();
  const environmentSet = new Set<string>();
  const customParamsMap = new Map<number, Set<string>>();

  placements.forEach((placement) => {
    // Count by DSP
    const dspName = placement.dspUIName;

    if (dspName) {
      countByDsp[dspName] = (countByDsp[dspName] || 0) + 1;
    }

    // Collect placement IDs
    if (placement.placementId) {
      placementIdSet.add(placement.placementId);
    }

    // Collect placement names
    if (placement.name) {
      placementNameSet.add(placement.name);
    }

    // Collect environments
    if (placement.environmentName) {
      environmentSet.add(placement.environmentName);
    }

    // Collect custom text params
    placement.customTextParams.forEach((param) => {
      if (param.value) {
        if (!customParamsMap.has(param.type)) {
          customParamsMap.set(param.type, new Set());
        }

        const paramSet = customParamsMap.get(param.type);

        if (paramSet) {
          paramSet.add(param.value);
        }
      }
    });
  });

  // Convert to arrays and take first 3 examples
  const placementIdExamples = Array.from(placementIdSet).slice(0, 3);
  const placementNameExamples = Array.from(placementNameSet).slice(0, 3);
  const distinctEnvironments = Array.from(environmentSet);

  // Process custom params
  const customParams: Record<number, {examples: string[]; distinctCount: number}> = {};

  customParamsMap.forEach((values, type) => {
    const valuesArray = Array.from(values);

    customParams[type] = {
      examples: valuesArray.slice(0, 3),
      distinctCount: valuesArray.length,
    };
  });

  return {
    isInCampaign: true,
    totalCount,
    countByDsp,
    placementIdExamples,
    placementNameExamples,
    distinctEnvironments,
    customParams,
  };
}
